<template>
    <div>
        <vs-row>
            <vs-col vs-align="left" vs-w="6">
                <vs-button
                    id="addResource"
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="showFormCreate"
                >
                    Ajouter un nouveau référentiel
                </vs-button>

                <DialogPrompt
                    :active.sync="showPopup"
                    :title="getDataPrompt.title"
                    cancel-text="Annuler"
                    accept-text="Enregistrer"
                    :button-accept="getDataPrompt.btnAccept"
                    :is-valid="!formError"
                    @cancel="resetResource"
                    @close="resetResource"
                    @accept="saveResource"
                >
                     <CatalogForm
                        v-model="resource"
                        :type="formType"
                        :establishmentNames="establishmentNames"
                        @error="setFormError"
                    />
                </DialogPrompt>

            </vs-col>
            <vs-col vs-type="flex" vs-align="left" vs-w="6" />
        </vs-row>

        <vs-table
            :sst="true"
            @search="eventSearchItems"
            @sort="eventSortByCol"
            search
            :no-data-text="loading ? `Chargement de vos données...` : `Aucune donnée à afficher`"
            style="width:100%"
            :data="itemsData"
            :loading="true"
            >
            <template slot="thead">
                <vs-th>
                    <Sort name="type" @sort="eventSortByCol">Type</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="title" @sort="eventSortByCol">Libellé</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="establishment_name" @sort="eventSortByCol">Organisme</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="is_graduate" @sort="eventSortByCol">Diplômant</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="active" @sort="eventSortByCol">Actif</Sort>
                </vs-th>
                <vs-th></vs-th>
            </template>

            <template>
                <vs-tr v-for="(item, i) in items.data" :key="i">
                    <vs-td>
                        <vs-chip v-for="(et, index) in get(item, ':experience_types')" :key="index" color="primary">
                            {{ et.name }}
                        </vs-chip>
                    </vs-td>
                    <vs-td>
                        {{ get(item, ':title') }}
                    </vs-td>
                    <vs-td>
                        {{ get(item, ':establishment_name') }}
                    </vs-td>
                    <vs-td>
                        <feather-icon
                            v-if="item.is_graduate"
                            icon="CheckSquareIcon"
                            svg-classes="h-6 w-6 icon-info vs-icon-primary"
                            class="ml-2"
                            v-tooltip="'Diplômant'"
                        />
                        <feather-icon
                            v-else
                            icon="SquareIcon"
                            svg-classes="h-6 w-6 icon-info"
                            class="ml-2"
                        />
                    </vs-td>
                    <vs-td>
                        <feather-icon
                            v-if="item.active"
                            icon="CheckSquareIcon"
                            svg-classes="h-6 w-6 icon-info vs-icon-primary"
                            class="ml-2"
                            v-tooltip="'Visible dans le catalogue'"
                        />
                        <feather-icon
                            v-else
                            icon="SquareIcon"
                            svg-classes="h-6 w-6 icon-info"
                            class="ml-2"
                        />
                    </vs-td>
                    <vs-td class="action">
                        <div class="action-wrapper">
                            <vs-button
                                v-if="can('update', 'catalogs', item.id)"
                                :id="'modifyCatalog_' + i"
                                v-tooltip="'Modifier'"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-edit"
                                @click.stop="showFormUpdate(item)"
                            />

                            <vs-button
                                v-if="can('delete', 'catalogs', item.id)"
                                :id="'deleteCatalog_' + i"
                                v-tooltip="'Supprimer'"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-trash"
                                @click.stop="removeResource(item)"
                            />
                        </div>
                    </vs-td>
                </vs-tr>
            </template>

        </vs-table>

        <vs-row>
            <vs-col class="mt-4" v-if="items.total > 0">
                <vs-pagination :total="Math.ceil(items.total / apiParams.perpage)" v-model="currentPage"></vs-pagination>
            </vs-col>
        </vs-row>
    </div>

</template>

<script>

import CatalogForm from '@components/views/rh/referentiel/catalog/CatalogForm';

export default {
    name: 'Catalogs',
    components: {
        CatalogForm
    },
    props: {
        api: {
            type: String
        },
        perpage: {
            type: String
        }
    },
    data() {
        return {
            log: console.log,
            config: [],
            currentPage: 1,
            loading: false,
            showPopup: false,
            isFormCreation: true,
            resource: {
                experience_types: null,
                title: null,
                nb_hours: null,
                establishment_name: null,
                is_graduate: null,
                active: true,
            },
            formError: true,
            formType: "create",
            prompt: {
                show: {
                    title: 'Consulter un référentiel',
                    btnAccept: 'false'
                },
                create: {
                    title: 'Ajouter un référentiel',
                    btnAccept: 'filled'
                },
                update: {
                    title: 'Modifier un référentiel existant',
                    btnAccept: 'filled'
                }
            }
        }
    },

    watch: {
        loading(value) {
            if (value) {
                this.$vs.loading()
            } else {
                this.$vs.loading.close()
            }
        }
    },

    computed: {
        getDataPrompt() {
            switch(this.formType) {
                case 'show':
                    return this.prompt.show
                    break;
                case 'create':
                    return this.prompt.create
                    break;
                case 'update':
                    return this.prompt.update
                    break;
                default:
                    return this.prompt.show
            }
        },

        establishmentNames() {
            console.log(window._.cloneDeep(this.itemsData))
            return this.itemsData.map(i => i.establishment_name) || []
        },
    },

    methods: {

        showFormCreate() {
            this.resetResource();
            this.formType = "create";
            this.showPopup = true
        },

        showFormUpdate(resource) {
            this.setResource(resource);
            this.formType = "update";
            this.showPopup = true
        },

        saveResource() {
            let data                = JSON.parse(JSON.stringify(this.resource));
            data.experience_types = data.experience_types.map(et => et.id);
            if (data.id) {
                this.apiUpdate(data, data.id,
                    (resp) => this.loadItems(),
                    (err)  => this.showPopup = true
                );
            } else {
                this.apiCreate(data,
                    (resp) => this.loadItems(),
                    (err)  => this.showPopup = true
                );
            }
        },

        removeResource(resource) {
            this.apiDelete(resource.id, () => this.loadItems());
        },

        setResource(data) {
            this.resource = JSON.parse(JSON.stringify(data));
        },

        resetResource() {
            this.resource = {
                experience_types: null,
                title: null,
                nb_hours: null,
                establishment_name: null,
                is_graduate: null,
                active: true,
            }
        },

        setFormError (value) {
            this.formError = value;
        },

    },
    created() {
        this.apiParams.include = ['experienceTypes'];
        this.loadItems();
    }
}
</script>
